export const meta: BlockMeta = {
  title: "Collections List",
  flags: {
    fullWidth: true,
  },
}

import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { TextImageThemeTile } from "@components/atoms/TextImageThemeTile"
import { Themed } from "@components/atoms/Themed"
import { ParallaxCarousel } from "@components/media/ParallaxCarousel"
import { cn } from "@utils/tw"
import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"
import { Link } from "eddev/routing"

export default defineBlock("collections/collections-list", (props) => {
  return (
    <div className="w-full my-7 flex flex-col gap-4">
      {props.collections?.nodes?.map((collection, index) => {
        const Wrap = collection.uri ? Link : "div"
        const wrapProps = collection.uri ? { href: collection.uri } : {}
        const images = (collection.films || [])
          .map((film) => ({ aspect: film?.media?.square?.aspect || 0, srcSet: film?.media?.square?.srcSet || "" }))
          .filter((f) => f.aspect !== 0 && f.srcSet !== "")
          .slice(0, 3)
        const shown =
          !collection.info?.hidden &&
          !collection.info?.unlisted &&
          collection.info?.public &&
          !!collection.films?.length

        return (
          shown && (
            <div key={collection.uri} className={cn("grid-auto mt-2 mb-5")}>
              <Themed
                theme={collection.info?.color || "none"}
                className="col-span-12 md:col-span-8 md:col-start-3 w-full"
              >
                <Wrap
                  {...wrapProps}
                  className={cn("flex flex-col md:flex-row gap-4 md:gap-8", collection.uri && "group/linked")}
                >
                  <div className="w-full flex flex-col gap-7 p-6">
                    <div className="w-full flex flex-col gap-4">
                      <p className="type-title-s hover-linked-group">{collection.title}</p>
                      <p className="type-body-s">{collection.info?.shortDescription}</p>
                    </div>
                    <div className="w-full flex flex-col gap-4">
                      <p className="type-label-s-light">{collection?.films?.length} Films</p>
                    </div>
                  </div>
                  <div
                    className={cn(
                      "w-full md:w-2/5 shrink-0 flex flex-col gap-2 pb-6 md:pb-0 md:pr-6 h-footerLogoH md:h-auto md:self-stretch md:min-h-[250px]",
                    )}
                  >
                    {images.map((image, i) => (
                      <div
                        key={i}
                        className={cn(
                          "w-full overflow-hidden relative",
                          images.length === 1 && "h-full",
                          images.length === 2 && "h-1/2",
                          images.length === 3 && "h-1/3",
                        )}
                      >
                        <ResponsiveImage {...image} className={cn("w-full h-full absolute")} objectFit="cover" />
                      </div>
                    ))}
                  </div>
                </Wrap>
              </Themed>
            </div>
          )
        )
      })}
    </div>
  )
})
